var swiper = new Swiper(".swiper-servicos", {
    slidesPerView: "auto",
    spaceBetween: 30,
    navigation: {
        nextEl: ".swiper-next",
        prevEl: ".swiper-prev",
    },
});

var swiper = new Swiper(".swiper-clientes", {
    slidesPerView: "auto",
    spaceBetween: 10,
    freeMode: true,
    loop: true,
    speed: 5000,
    autoplay: {
        delay: 1,
        disableOnInteraction: false,
    }
});